export default "__VITE_ASSET__0441f064__"